import { connect } from 'react-redux'
import React from 'react'
import Members from '../Components/Members/Members'
import { IsFromSearchContextConsumer } from '../Providers/IsFromSearch'

const MembersContainer = (props) => {
    return (
        <IsFromSearchContextConsumer>
            {isFromSearch => {
                return (
                    <Members
                        {...props}
                        isFromSearch={isFromSearch}
                    />
                )
            }}
        </IsFromSearchContextConsumer>
    )
}

import mapStateToProps from '../Components/ViewClanProfile/MapStateToProps'
import mapDispatchToProps from '../Components/ViewClanProfile/MapDispatchToProps'

export default connect(mapStateToProps, mapDispatchToProps)(MembersContainer)
